import { StyleSheet, ViewStyle, StyleProp } from "react-native";
import { useTheme } from "@/hooks/useTheme";
import { PropsWithChildren } from "react";
import { BlurView } from "expo-blur";

type DrawerProps = PropsWithChildren & {
  style?: StyleProp<ViewStyle>;
  width?: number;
};

export function Drawer({ width = 375, style, children }: DrawerProps) {
  const { colors } = useTheme();

  return (
    <BlurView
      tint={colors.name === "dark" ? "dark" : "light"}
      intensity={colors.name === "dark" ? 90 : 70}
      collapsableChildren={true}
      style={[styles.container, { borderColor: colors.border, width: width }, style]}
    >
      {children}
    </BlurView>
  );
}

const styles = StyleSheet.create({
  container: {
    height: "100%",
    borderRightWidth: 1,
    padding: 8,
    paddingVertical: 16,
    zIndex: 1,
    elevation: 1,
  },
});
